import { Factory } from 'rosie';

Factory.define('CustomerUsernameAddress');

Factory.define('CustomerUsernameAddressWithDefaults')
  .extend('CustomerUsernameAddress')
  .attr('username', '14151112222');



// WEBPACK FOOTER //
// ./factories/customer_username_address_factory.js